import * as React from "react";
import type { SVGProps } from "react";
const SvgEmptySheets = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={47}
    height={37}
    fill="none"
    viewBox="0 0 47 37" {...props}
  >
    <path
      fill="url(#empty-sheets_svg__a)"
      d="m2.393 24.349-1.61 2.658a1.646 1.646 0 0 0 .764 2.36l15.698 6.616c1.013.429 2.17.238 2.992-.477l2.682-2.337 3.04 1.061a3.66 3.66 0 0 0 3.504-.655c2.73-2.253 8.32-7.188 11.908-12.48 3.278-4.84 4.744-7.963 5.388-9.62.643-1.657-.12-1.597-.906-1.823L32.8 5.766z"
      opacity={0.6}
    />
    <path
      fill="#fff"
      stroke="#00217B"
      strokeDasharray="1.72 1.72"
      strokeMiterlimit={10}
      strokeWidth={0.859}
      d="M9.758 24.79c-1.06-.405-1.299-1.8-.429-2.526 2.289-1.92 6.163-5.46 9.56-9.965 3.457-4.59 5.805-8.225 6.997-10.168a2.37 2.37 0 0 1 2.67-1.037L44.1 5.552c1.144.334 1.74 1.597 1.251 2.682-1.216 2.718-3.671 7.712-7.187 12.754-3.207 4.601-6.58 7.522-8.69 9.083-2.11 1.562-2.86 1.144-4.303.596z"
    />
    <path
      fill="#fff"
      stroke="#00217B"
      strokeDasharray="1.72 1.72"
      strokeMiterlimit={10}
      strokeWidth={0.859}
      d="M37.555 11.201c-1.312 2.67-3.934 7.593-7.617 12.504-2.086 2.778-4.196 4.911-6.032 6.485a39 39 0 0 1-2.968 2.3 4.5 4.5 0 0 1-4.315.441l-15.21-6.4a1.1 1.1 0 0 1-.262-.144c-.81-.548-.894-1.764-.083-2.396 2.36-1.847 6.341-5.244 9.893-9.643.012-.024.036-.048.048-.06.155-.178.298-.37.441-.548 3.338-4.184 5.65-7.497 6.854-9.31a2.364 2.364 0 0 1 2.706-.94l3.325 1.072 6.819 2.217 5.232 1.693a1.965 1.965 0 0 1 1.157 2.73z"
    />
    <defs>
      <linearGradient
        id="empty-sheets_svg__a"
        x1={0.545}
        x2={46.842}
        y1={20.999}
        y2={20.999}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#258AE9" />
        <stop offset={0.2} stopColor="#228FE6" />
        <stop offset={0.5} stopColor="#1AA0E0" />
        <stop offset={0.7} stopColor="#0DBBD6" />
        <stop offset={1} stopColor="#00DACB" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgEmptySheets;
